<section
  class="device-certificates"
  aria-labelledby="device-certificates-title"
>
  <details>
    <summary>
      <span class="certificates-title-group">
        <span id="device-certificates-title" class="certificates-title">
          {{ 'device_certificates.title' | translate }}
        </span>
        <span class="certificates-description">
          {{ 'device_certificates.description' | translate }}
        </span>
      </span>
      <span class="certificates-summary-status">
        {{
          'device_certificates.valid_count' | translate: { count: validCount }
        }}
        <ng-container *ngIf="revokedCount > 0">
          ·
          {{
            'device_certificates.revoked_count'
              | translate: { count: revokedCount }
          }}
        </ng-container>
      </span>
      <span class="certificates-chevron" aria-hidden="true"></span>
    </summary>

    <div class="certificates-content">
      <div *ngIf="revokeError" class="revoke-error" role="alert">
        {{ revokeError }}
      </div>

      <article
        *ngFor="
          let certificate of sortedCertificates;
          trackBy: trackCertificate
        "
        class="certificate-card"
        [class.certificate-revoked]="isRevoked(certificate)"
      >
        <div class="certificate-heading">
          <span
            class="certificate-status"
            [class.status-revoked]="isRevoked(certificate)"
            [class.status-expired]="
              !isRevoked(certificate) && isExpired(certificate)
            "
          >
            {{
              (isRevoked(certificate)
                ? 'device_certificates.status.revoked'
                : isExpired(certificate)
                  ? 'device_certificates.status.expired'
                  : 'device_certificates.status.valid'
              ) | translate
            }}
          </span>
          <code class="certificate-thumbprint" [title]="certificate.thumbprint">
            {{ certificate.thumbprint }}
          </code>
          <button
            *ngIf="canRevoke && !isRevoked(certificate) && !certificate.failure"
            type="button"
            class="revoke-button"
            [disabled]="!!revokingThumbprint"
            (click)="revoke(certificate)"
          >
            {{
              (revokingThumbprint === certificate.thumbprint
                ? 'device_certificates.revoke.in_progress'
                : 'device_certificates.revoke.button'
              ) | translate
            }}
          </button>
        </div>

        <p *ngIf="certificate.failure" class="certificate-failure">
          {{ certificate.failure }}
        </p>

        <dl *ngIf="!certificate.failure" class="certificate-dates">
          <div>
            <dt>{{ 'device_certificates.registered' | translate }}</dt>
            <dd>
              <ng-container
                *ngTemplateOutlet="
                  timestamp;
                  context: { $implicit: certificate.createdAt }
                "
              ></ng-container>
            </dd>
          </div>
          <div>
            <dt>{{ 'device_certificates.expires' | translate }}</dt>
            <dd>
              <ng-container
                *ngTemplateOutlet="
                  timestamp;
                  context: { $implicit: certificate.expiresAt }
                "
              ></ng-container>
            </dd>
          </div>
          <div *ngIf="certificate.revokedAt">
            <dt>{{ 'device_certificates.revoked' | translate }}</dt>
            <dd>
              <ng-container
                *ngTemplateOutlet="
                  timestamp;
                  context: { $implicit: certificate.revokedAt }
                "
              ></ng-container>
              <small *ngIf="displayName(certificate.revokedBy) as revokedBy">
                {{ 'device_certificates.by' | translate }} {{ revokedBy }}
                <ng-container
                  *ngIf="
                    displayName(
                      certificate.revokedBy?.impersonatedBy
                    ) as impersonator
                  "
                >
                  {{ 'device_certificates.impersonated_by' | translate }}
                  {{ impersonator }}
                </ng-container>
              </small>
            </dd>
          </div>
        </dl>

        <section
          *ngIf="certificate.approvals?.length"
          class="certificate-approvals"
        >
          <h3>{{ 'device_certificates.approvals.title' | translate }}</h3>
          <ul>
            <li *ngFor="let approval of certificate.approvals">
              <ng-container
                *ngTemplateOutlet="
                  timestamp;
                  context: { $implicit: approval.approvedAt }
                "
              ></ng-container>
              <span class="approval-by">
                {{ 'device_certificates.by' | translate }}
                {{
                  displayName(approval.approvedBy) ||
                    ('device_certificates.approvals.unknown_user' | translate)
                }}
                <ng-container
                  *ngIf="approval.privilegedRole || approval.role as role"
                >
                  ({{ formatRole(role) }})
                </ng-container>
              </span>
              <span *ngIf="approval.note" class="approval-note">
                “{{ approval.note }}”
              </span>
            </li>
          </ul>
        </section>
      </article>
    </div>
  </details>
</section>

<ng-template #timestamp let-value>
  <time
    *ngIf="value; else notAvailable"
    [attr.datetime]="value"
    [title]="formatTime(value)"
  >
    <span>{{ formatTime(value) }}</span>
    <span class="relative-time">({{ formatTimeAgo(value) }})</span>
  </time>
  <ng-template #notAvailable>
    {{ 'device_certificates.not_available' | translate }}
  </ng-template>
</ng-template>
